import React, { useEffect, useState } from "react";
import svgSortAsc from "../../svgs/arrow-up.svg";
import Icon from "../Icon";
import { fetchData, mutateData } from "../Service/graphQlService";
import { browserHistory } from "react-router";
import Alert from "../Alert/Alert";
import { CREATE_OR_UPDATE_NEWS, GET_NEWS_QUERY } from "../Graphql/Queries/NewsQuery";
import { formatDateToMMDDYYYY, getIsoDate } from "../../utils";

const News = (props) => {
  const [title, setTitle] = useState();
  const [text, setText] = useState();
  const [sourceName, setSourceName] = useState();
  const [sourceUrl, setSourceUrl] = useState();
  const [date, setDate] = useState();
  const [deleted, setDeleted] = useState();
  const [original, setOriginal] = useState({title: "", text: ""});
  const [edit, setEdit] = useState(!props.edit || false);
  const [isBusy, setIsBusy] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const id = props.params.id || false;

  useEffect(() => {
    if (id) {
      fetchData(GET_NEWS_QUERY, { arcimedesRowId: parseInt(id) })
        .then(res => {
          setTitle(res.data.getNews.title);
          setText(res.data.getNews.text);
          setSourceName(res.data.getNews.source_name);
          setSourceUrl(res.data.getNews.source_url);
          setDate(formatDateToMMDDYYYY(res.data.getNews.date));
          setDeleted(res.data.getNews.deleted);
          setOriginal({title: res.data.getNews.title, text: res.data.getNews.text, source_name: res.data.getNews.source_name, source_url: res.data.getNews.source_url, date: formatDateToMMDDYYYY(res.data.getNews.date), deleted: res.data.getNews.deleted});
        })
        .catch(error => console.error('Error fetching event:', error));
    }
  }, [id]);



  const toggleEdit = () => {
    setEdit(!edit);
  };

  const handleDelete = () => {
    if(deleted === null){
      saveEditorContent(1);
    }else{
      saveEditorContent();
    }
  };
  
  const cancelEditorChanges = () => {
    if(!props.edit){
      history.back();
      return;
    }
    setTitle(original.title);
    setText(original.text);
    setEdit(false);
  };

  const saveEditorContent = async (deleted=null) => {
    setIsBusy(true);
    setError("");
    setSuccess(false);
    try {
      if (!title || !text) {
        setError("Title and Website cannot be empty.");
        return;
      }
      const input = {
        title,
        text,
        source_name: sourceName,
        date: getIsoDate(date),
        deleted: deleted
      };
      if (id) {
        input.arcimedes_row_id = parseInt(id);
      }
      const res = await mutateData(CREATE_OR_UPDATE_NEWS,  {input})
      if (res && res.data.createOrUpdateNews.success) {
        setTitle(res.data.createOrUpdateNews.news.title);
        setText(res.data.createOrUpdateNews.news.text);
        setSourceName(res.data.createOrUpdateNews.news.source_name);
        setSourceUrl(res.data.createOrUpdateNews.news.source_url);
        setDate(formatDateToMMDDYYYY(res.data.createOrUpdateNews.news.date));
        setDeleted(res.data.createOrUpdateNews.news.deleted);
        setOriginal({title: res.data.createOrUpdateNews.news.title, text: res.data.createOrUpdateNews.news.text, source_name: res.data.createOrUpdateNews.news.source_name, source_url: res.data.createOrUpdateNews.news.source_url, date: formatDateToMMDDYYYY(res.data.createOrUpdateNews.news.date), deleted: res.data.createOrUpdateNews.news.deleted});
        if (!id && !props.edit) {
          browserHistory.push({
            pathname: `/news/${res.data.createOrUpdateNews.news.arcimedes_row_id}`,
          });
        }
        setSuccess('Saved');
      }else{
        setError("Failed to save changes.");
      }
    } catch (err) {
      setError("Failed to save changes.");
    } finally {
      setIsBusy(false);
      setEdit(false);
    }
  };

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 5000);
  
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <div className="ContentPage">
      <div className="page-rounded-corner-container">
        <div className="page-header-container">
          <div
            className="page-back-button"
            onClick={() => {
              history.back();
            }}
          >
            <Icon svg={svgSortAsc} />
            News
          </div>
          <div className="page-header">
            <div className="page-title">{title && props.edit? title.length > 16 ? `${title.substring(0, 16)}...` : title : !props.edit ? 'Add News': 'News Title'}</div>
            {!edit && <div className="button-new negative" onClick={handleDelete}>
                  {deleted == null ? 'Delete': 'Undelete'}
                </div>}
            {edit && (
              <React.Fragment>
                <div
                  className="button-new negative"
                  onClick={cancelEditorChanges}
                >
                  Cancel
                </div>
                <div
                  className="button-new positive"
                  onClick={()=>!isBusy ? saveEditorContent() : null} // Prevent multiple clicks while busy
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  {isBusy ? (
                    <div
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid transparent',
                        borderTop: '2px solid #fff',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                      }}
                    />
                  ) : (
                    props.edit ? 'Save' : 'Add'
                  )}
                </div>
              </React.Fragment>
            )}
            {!edit && (
              <div className="button-new positive" onClick={toggleEdit}>
                Edit
              </div>
            )}
          </div>
           {success ? <Alert type="success">{success}</Alert> : null}
          {error ? <Alert type="error">{error}</Alert> : null}
          <div className="line" />
        </div>
      </div>
      <div className="page-body-container">
        <label>
          Title:
          <br />
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            style={{ width: "100%", marginBottom: "1rem" }}
            disabled={!edit}
          />
        </label>
        <br />
        <label>
          Website:
          <br />
          <textarea
            rows={15}
            value={text}
            onChange={(e) => setText(e.target.value)}
            style={{ width: "100%" }}
            disabled={!edit}
          />
        </label>
        <br />
        <label>
          Source Name:
          <br />
          <textarea
            rows={15}
            value={sourceName}
            onChange={(e) => setSourceName(e.target.value)}
            style={{ width: "100%" }}
            disabled={!edit}
          />
        </label>
        <br />
        <label>
          Date:
          <br />
          <input
            type="text"
            value={date}
            placeholder="MM/DD/YYYY"
            onChange={(e) => setDate(e.target.value)} // Handle date changes
            style={{ width: "100%", marginBottom: "1rem" }}
            disabled={!edit}
          />
        </label>
      </div>
    </div>
  );
};

export default News;
